import Jumbotron from "components/Jumbotron";
import { setBreadcrumbTitle } from "features/breadcrumb/breadcrumbSlice";
import { ErrorMessage, SubmitButton } from "features/payment/paymentPageStyles";
import React, { useEffect, useRef } from "react";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import styled from "styled-components";
import { Input } from "components/MessageUs/MessageUs";
import { unsubscribe } from "features/admin/EmailSender/emailSenderSlice";

const Unsubscribe: React.FC = () => {
  const dispatch = useDispatch();
  const { register, control, handleSubmit, errors } = useForm();
  useEffect(() => {
    dispatch(setBreadcrumbTitle("Отписване"));

    return () => {
      dispatch(setBreadcrumbTitle(""));
    };
  }, []);
  const onFormSubmit = async (data: any) => {
    if (!data.emailFake) {
      dispatch(unsubscribe(data.email));
    }
  };
  return (
    <UnsubscribeContainer>
      <Jumbotron>
        <h3>
          Отпишете се от нашия бюлетин
          <p className="caption">въведете имейл адреса си</p>
        </h3>

        {errors.email && errors.email?.type === "pattern" && (
          <ErrorMessage>Грешен формат имейл формат.</ErrorMessage>
        )}
        <InputContainer onSubmit={handleSubmit(onFormSubmit)}>
          <Input
            className="text-body"
            type="email"
            name="email"
            ref={register({
              required: true,
              pattern: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/,
            })}
            placeholder="* Имейл адрес"
          />
          <Input
            className="text-body"
            name="emailFake"
            style={{ display: "none" }}
          />
          <SubmitButton
            className="submit-button text-md"
            type="submit"
            value="Отпиши се"
          />
        </InputContainer>
      </Jumbotron>
    </UnsubscribeContainer>
  );
};

const UnsubscribeContainer = styled.div`
  display: flex;
  justify-content: center;
`;

const InputContainer = styled.form`
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  width: 100%;

  .submit-button {
    border-radius: 5px;
    margin-top: 20px;
  }
`;
export default Unsubscribe;
